import { ScopeKey } from '../edit-session/ScopeKey';
import { InputDataDetailsKey } from './schema/types';
export const InputDataScopeKey = {
  create: (key: InputDataDetailsKey) =>
    ScopeKey.join(
      key.descriptionId ?? '',
      key.groupId ?? '',
      key.valueDate,
      key.subject,
      key.dataStatus ?? '',
      key.versionId ?? '',
    ),
};
